export default "__VITE_ASSET__0cac82e7__"